import React from 'react';
import { useSelector } from 'react-redux';

// Utils
import { getDefaultAvatarColor } from 'Shared/utils/getDefaultAvatarColor';

// Components
import WpAvatar from 'Wpds/components/avatar/WpAvatar';
import WpIcon from 'Wpds/components/icon/WpIcon';

// Styles
import './SurfaceItemAvatar.scss';
import { useWorkspace } from 'Shared/utils/hooks/use-workspace';

type Props = {
  userId;
  displayName;
};

const SurfaceItemAvatar = ({ userId, displayName }: Props) => {
  // If state.workspace is not set, we're most likely
  // looking at the surfaceAI table in another location
  // like the team page. Fall back on the All hands to get
  // user avatars from as a fail safe
  const { workspace: currentWorkspace } = useWorkspace();
  const teamSyncWorkspace = useSelector(state => state.workspaces.find(({ isTeamSync }) => isTeamSync));
  let users = [];

  if (!userId && !displayName) return <WpIcon name="user" />;

  // state.workspace redux is reset with empty objects
  // need to check and see if a name is set to confirm it's there
  if (currentWorkspace.name) {
    users = currentWorkspace.users;
  } else if (teamSyncWorkspace) {
    users = teamSyncWorkspace.users;
  }

  const user = users.find(({ id }) => id == userId);
  const initials = displayName.includes(' ')
    ? displayName.substr(0, 1) + displayName.split(' ')[1].substr(0, 1)
    : displayName.substr(0, 1);

  const avatar = user ? user.avatar : { initials, color: getDefaultAvatarColor(displayName.toLowerCase()) };

  const baseClassName = 'SurfaceItemAvatar';

  return (
    <>
      <div className={`${baseClassName}__avatar`}>
        <WpAvatar avatar={avatar} size="sm" />
      </div>
      <div className={`${baseClassName}__label`}>{displayName}</div>
    </>
  );
};

export default SurfaceItemAvatar;
